var AvailableStoreForProductSelector = class extends HTMLElement {
    constructor() {
      super();
      this.inputField = this.querySelector("input");
    }
  
    connectedCallback() {
      this.inputField.addEventListener(
        "change",
        this.handleStoreSelection.bind(this)
      );
    }
    disconnectedCallback() {
      this.inputField.removeEventListener(
        "change",
        this.handleStoreSelection.bind(this)
      );
    }
  
    handleStoreSelection() {
      const selectedStore = this.inputField.checked
        ? this.inputField.getAttribute("data-hanlde")
        : "";
      this.inputField
        .closest(".store-container")
        .querySelectorAll("input")
        .forEach((input) => {
          if (input !== this.inputField) {
            input.checked = false;
          }
        });
      localStorage.setItem("selected-store", selectedStore);
      location.reload();
    }
  };
  
  if (!window.customElements.get("avaiable-store-selector")) {
    window.customElements.define(
      "avaiable-store-selector",
      AvailableStoreForProductSelector
    );
  }
  
  var OtherAvaiableStores = class extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector(".show-other-avaiable-stores");
    }
  
    connectedCallback() {
      this.btn.addEventListener("click", this.showOtherStores.bind(this));
    }
  
    disconnectedCallback() {
      this.btn.removeEventListener("click", this.showOtherStores.bind(this));
    }
  
    showOtherStores() {
      const storeContainer = this.closest(".store-container");
      storeContainer.classList.remove("show-other-avaiable-stores-disabled");
      this.btn.closest(".active-store-available-footer").remove();
    }
  };
  
  if (!window.customElements.get("other-available-stores")) {
    window.customElements.define("other-available-stores", OtherAvaiableStores);
  }
  
  var RenderAvailableStores = class extends HTMLElement {
    constructor() {
      super();
      this.productId = this.getAttribute("data-product-id");
      this.variantId = this.getAttribute("data-variant-id");
    }
  
    connectedCallback() {
      this.renderStores();
      this.isProductAvaiablePickUpWidget();
      this.isProductAvaiableOnline(this.variantId);
    }
   refresh() {

    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);
    const searchParams = new URLSearchParams(urlObj.search);
    const variant = searchParams.get('variant');
    this.variantId = variant;

    // Clear old rendered innerHTML
    document.querySelector(".pickup-availability-widget").innerHTML = "";
    document.querySelector(".pickup-availibility-container").innerHTML = "";
    document.querySelector(".online-availibility-container").innerHTML = "";
        this.style.display = 'block';

    // Re-render stores and availability
    this.renderStores();
    this.isProductAvaiablePickUpWidget();
    this.isProductAvaiableOnline(this.variantId);
  }
  
    async checkStore() {
      const locations = await this.fetchLocations(this.productId, this.variantId);
      const selectedStore = localStorage.getItem("selected-store");
  
      if (selectedStore == null || selectedStore !== "") {
        const selectedStoreArray = locations.locations
          .filter((store) => store.company_name === selectedStore)
          .map((store) => ({ ...store, activeStore: true }));
        const otherStoresArray = locations.locations
          .filter((store) => store.company_name !== selectedStore)
          .map((store) => ({ ...store, activeStore: false }));
        const sortedStores = [...selectedStoreArray, ...otherStoresArray];
        return sortedStores;
      } else {
        return locations.locations.map((store) => ({
          ...store,
          activeStore: false,
        }));
      }
    }
    async  isProductAvaiablePickUpWidget() {
      const selectedStore = localStorage.getItem("selected-store");
      if (selectedStore == null || selectedStore == "" || this.variantId == null) {
        return;
      }
      let data = await this.fetchLocations(this.productId, this.variantId);
      let resultContainer = document.querySelector(
        ".pickup-availibility-container"
      );
      let foundFlag = false;
      
      data.locations.forEach((location) => {
        if (location.company_name == selectedStore) {
          resultContainer.innerHTML = `<span class="alert alert--circle alert--error alert--error--no-bg alert--error--green"> In Stock at ${selectedStore} </span>`;
          foundFlag = true;
          return;
        }
      });
      if (!foundFlag) {
        resultContainer.innerHTML = `<span class="alert alert--circle alert--error alert--error--no-bg alert--error--red"> Out of Stock at ${selectedStore} </span>`;
      }
    }
    async renderStores() {
      let stores = await this.checkStore();
      if (stores.length == 0) {
        const pickupAvailabilityWidgetHeader = document.querySelector(
          ".pickup-availability-widget__header"
        );
        pickupAvailabilityWidgetHeader.innerHTML = `
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m.928827 2.34315 1.414213-1.414218 5.65685 5.656858 5.65681-5.656858 1.4143 1.414218-5.65689 5.65685 5.65689 5.6569-1.4143 1.4142-5.65681-5.65689-5.65685 5.65689-1.414213-1.4142 5.656853-5.6569z" fill="#000"></path><path d="m.928827 2.34315 1.414213-1.414218 5.65685 5.656858 5.65681-5.656858 1.4143 1.414218-5.65689 5.65685 5.65689 5.6569-1.4143 1.4142-5.65681-5.65689-5.65685 5.65689-1.414213-1.4142 5.656853-5.6569z" stroke="#000"></path></svg>
      <span >This product is not available for pickup at any store</span>
      `;
  
        return;
      }
      let activeStore = stores.filter((store) => store.activeStore === true);
  
      // Get inactive stores
      let inactiveStores = stores.filter((store) => store.activeStore === false);
      // Add latitude and longitude values to inactive stores
      inactiveStores = inactiveStores.map((inactiveStore) => {
        // Find the matching store from STORES
        const matchingStore = STORES.find(
          (store) => store.company_name === inactiveStore.store_name
        );
  
        if (matchingStore) {
          // Add new properties to the inactiveStore object
          inactiveStore.store_map_latitude = matchingStore.store_map_latitude;
          inactiveStore.store_map_longitude = matchingStore.store_map_longitude;
        }
  
        return inactiveStore;
      });
      //  Sort by distance if the user allowed location access
      if (navigator.geolocation) {
        function getDistance(lat1, lon1, lat2, lon2, unit) {
          if (lat1 == lat2 && lon1 == lon2) {
            return 0;
          } else {
            var radlat1 = (Math.PI * lat1) / 180;
            var radlat2 = (Math.PI * lat2) / 180;
            var theta = lon1 - lon2;
            var radtheta = (Math.PI * theta) / 180;
            var dist =
              Math.sin(radlat1) * Math.sin(radlat2) +
              Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
              dist = 1;
            }
            dist = Math.acos(dist);
            dist = (dist * 180) / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit == "K") {
              dist = dist * 1.609344;
            }
            if (unit == "N") {
              dist = dist * 0.8684;
            }
            return dist;
          }
        }
        navigator.geolocation.getCurrentPosition(function (position) {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
  
          inactiveStores.sort((a, b) => {
            const distA = getDistance(
              latitude,
              longitude,
              a.store_map_latitude,
              a.store_map_longitude,
              "K"
            );
            const distB = getDistance(
              latitude,
              longitude,
              b.store_map_latitude,
              b.store_map_longitude,
              "K"
            );
            return distA - distB;
          });
        });
      }
      stores = [...activeStore, ...inactiveStores];
      const storesContainer = document.querySelector(
        ".pickup-availability-widget"
      );
      storesContainer.innerHTML = "";
      const storeContainer = document.createElement("div");
      storeContainer.classList.add("store-container");
  
      stores.forEach((store) => {
        const storeElement = document.createElement("div");
  
        if (activeStore.length > 0) {
          if (store.activeStore) {
            storeContainer.classList.add("show-other-avaiable-stores-disabled");
            storeElement.innerHTML = `
          
           <avaiable-store-selector>
           <div>
             <div class="active-store-available-header store-avaiable-selector-padding">
               Available for pickup at
             </div>
          
             <div class="avaialble-store-selectoer-item store-avaiable-selector-padding">
                 <div class="avaialble-store-selectoer-item-left" >
                 <input data-hanlde='${
                   store.company_name
                 }' type="checkbox" class="styled-checkbox" id="store-select-healthy-spot-beverly-grove-pick-up" ${
              store.activeStore ? "checked" : ""
            }>
                 <div class="avaialble-store-selectoer-item-left-content">
                   <span class="active-store-green">${store.company_name}</span>
                   <span>${store.address_line_1},${store.region}</span>
                 </div>
                 </div>
                 <div class="avaialble-store-selectoer-item-right">
                 </div>
             </div>
           </div>
           ${
             stores.length > 1
               ? `
               <div class='active-store-available-footer store-avaiable-selector-padding'>
               <other-available-stores>
                 <span class='show-other-avaiable-stores'>Check availability at other stores</span>
                 </other-available-stores>
               </div>
               `
               : ""
           }
           </avaiable-store-selector>
       `;
            storeContainer.appendChild(storeElement);
          } else {
            storeElement.innerHTML = `
           <avaiable-store-selector>
           <div class="store-selector-item__container  store-selector-product-avaiable store-selector-product-avaiable-other">
             <input data-hanlde='${
               store.company_name
             }' type="checkbox" class="styled-checkbox" id="store-select-healthy-spot-beverly-grove-pick-up" ${
              store.activeStore ? "checked" : ""
            }>
             <div >
               <span class="store-selector-item__title"><strong>${
                 store.company_name
               }</strong></span>
               <span class="store-selector-item__subtitle">
                 <span>${store.address_line_1},${store.region}</span>
               </span>
             </div>
           </div>
           </avaiable-store-selector>
       `;
            storeContainer.appendChild(storeElement);
          }
        } else {
          storeElement.innerHTML = `
           <avaiable-store-selector>
           <div class="store-selector-item__container  store-selector-product-avaiable store-selector-product-avaiable-other">
             <input data-hanlde='${
               store.company_name
             }' type="checkbox" class="styled-checkbox" id="store-select-healthy-spot-beverly-grove-pick-up" ${
            store.activeStore ? "checked" : ""
          }>
             <div >
               <span class="store-selector-item__title"><strong>${
                 store.company_name
               }</strong></span>
               <span class="store-selector-item__subtitle">
                 <span>${store.address_line_1},${store.region}</span>
               </span>
             </div>
           </div>
           </avaiable-store-selector>
       `;
          storeContainer.appendChild(storeElement);
        }
      });
      storesContainer.appendChild(storeContainer);
        this.style.display = 'none';

    }
    async  fetchLocations(productId, variantId) {
      const response = await fetch('https://api-us.zapiet.com/v1.0/pickup/locations?shop=' + zapietShopUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "shoppingCart": [
            {
              "variant_id": variantId,
              "product_id": productId,
              "quantity": 1
            }
          ]
        })
      });
      
      return await response.json();
    }
    async  isProductAvaiableOnline(productVariantId){
      if (!productVariantId) {
        return;
      }
      const response = await fetch(
        zapietGadgetAppBaseUrl + "isAvailable",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productVariantId: productVariantId,
            quantity: 1,
          }),
        }
      );
      const data = await response.json();
      let resultContainer = document.querySelector(".online-availibility-container")
      if(data.available){
        resultContainer.innerHTML = `<span class="alert alert--circle alert--error alert--error--no-bg alert--error--green">  In Stock Online </span>`;
      }else{
        resultContainer.innerHTML = `<span class="alert alert--circle alert--error alert--error--no-bg alert--error--red"> Out of Stock Online </span>`;
      }
    }
  };
  if (!window.customElements.get("render-available-stores")) {
    window.customElements.define(
      "render-available-stores",
      RenderAvailableStores
    );
  }
  